module.exports = __webpack_public_path__ + "media/dashboard/assets/images/typing-6027d21b24f45e3377a729a55158f948.gif";